import { STORY_TYPES } from '@/constants/STORY_TYPES.ts'
import { cn } from '@/lib/utils'
import { useMemo } from 'react'

type Props = {
  storyType: StoryType
  className?: string
  isAlert?: boolean
}

export const StoryTypeIcon = ({ storyType, className, isAlert }: Props) => {
  const iconPath = useMemo(() => {
    switch (storyType) {
      case STORY_TYPES.DESIGN:
        return '/images/story-type-ui-icon.svg'
      case STORY_TYPES.BUG:
        return '/images/story-type-bug-icon.svg'
      case STORY_TYPES.CHORE:
        return '/images/story-type-chore-icon.svg'
      case STORY_TYPES.RELEASE:
        return isAlert ? '/images/story-type-release-icon-alert.svg' : '/images/story-type-release-icon.svg'
      default:
        return '/images/story-type-feature-icon.svg'
    }
  }, [storyType, isAlert])
  return (
    <img
      className={cn(className, { 'bg-transparent': storyType === STORY_TYPES.RELEASE })}
      src={iconPath}
      alt={`${storyType.toLowerCase()} icon`}
    />
  )
}
